<template>
	<bernstein-layout>
		<form
			@submit.prevent="submit_selected_list"
			class="mx-auto mt-10 text-center"
		>
			<div>
				<jet-button
					class="rounded font-bold text-white"
					:class="{ 'opacity-25': form.processing }"
					:disabled="form.processing"
				>
					Create Stock List<br />
					for Transport
				</jet-button>
			</div>

			<div
				v-if="list_length > 0"
				class="border-3 mx-2 my-4 flex flex-col border border-blue-600 bg-gray-50 px-6 py-4 shadow-md"
			>
				<div class="my-4 p-2">
					<div class="mx-auto flex flex-row justify-center">
						<div class="align-center flex flex-col justify-center text-center">
							<input
								class="mx-auto"
								type="checkbox"
								id="lager_hochheim"
								:value="lagerHochheim"
								@change="
									select_email_from_list($event)
									// select_email_from_list('lager_hochheim', this.lager_hochheim)
									// update_email_list($event)
								"
							/>
							<label class="text-center">Lager Hochheim</label>
						</div>
						<div class="align-center flex flex-col justify-center px-2">
							<input
								class="mx-auto"
								type="checkbox"
								id="lager_keramag"
								:value="lagerKeramag"
								@change="
									select_email_from_list($event)
									// select_email_from_list('lager_hochheim', this.lager_hochheim)
									// update_email_list($event)
								"
							/>
							<label class="">Lager Keramag</label>
						</div>
						<!-- packect dienst  -->
						<div class="align-center flex flex-col justify-center px-2">
							<input
								class="mx-auto"
								type="checkbox"
								id="paketdienst"
								:value="paketdienst"
								@change="
									select_email_from_list($event)
									// select_email_from_list('lager_hochheim', this.lager_hochheim)
									// update_email_list($event)
								"
							/>
							<label class="">Paketdienst</label>
						</div>
						<!-- packect dienst  -->
						<div class="align-center flex flex-col justify-center px-2">
							<input
								class="mx-auto"
								type="checkbox"
								id="bUsel"
								:value="bUsel"
								@change="
									select_email_from_list($event)
									// select_email_from_list('lager_hochheim', this.lager_hochheim)
									// update_email_list($event)
								"
							/>
							<label class="">Bülent Usel</label>
						</div>
					</div>
					<div class="mt-4">
						<jet-label for="email" value="Email" />
						<jet-input
							id="email"
							type="text"
							class="mt-1 block w-full"
							:value="form.email_list"
							@change="update_email_list($event)"
							required
						/>
					</div>
				</div>
				<table>
					<thead>
						<tr>
							<th>Selection</th>
							<th>ItemId</th>
							<th>VariationId</th>
							<th>Name</th>
							<th>Main Warehouse</th>
							<th>From</th>
							<th>To</th>
							<th>Exisiting Quantity</th>
							<th>Transport Quantity</th>
							<th>Kommentare</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(listKey, kIndx) in list_keys"
							:key="kIndx"
							v-bind="get_transport_list_row(kIndx)"
							class="my-2 py-2"
						>
							<td>
								<input
									type="checkbox"
									:id="kIndx"
									:name="
										form.selected_list[this.get_plenty_id(listKey)][
											'variationId'
										]
									"
									:value="
										form.selected_list[this.get_plenty_id(listKey)]['checked']
									"
									class="rounded border-2 border-gray-900 p-6 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
									:checked="
										form.selected_list[this.get_plenty_id(listKey)]['checked']
									"
									@change="update_transport_listitem($event, listKey)"
								/>
							</td>
							<td>
								{{ form.selected_list[this.get_plenty_id(listKey)]["itemId"] }}
							</td>
							<td>
								{{
									form.selected_list[this.get_plenty_id(listKey)]["variationId"]
								}}
							</td>
							<td>
								{{ form.selected_list[this.get_plenty_id(listKey)]["name"] }}
							</td>
							<td>
								{{
									form.selected_list[this.get_plenty_id(listKey)][
										"main_warehouse"
									]
								}}
							</td>
							<!-- from ware house  -->
							<!-- @change="$emit('update_from_warehouse', $event.target.value)" -->
							<td>
								<select
									@change="update_from_warehouse($event, listKey)"
									:value="
										form.selected_list[this.get_plenty_id(listKey)][
											'from_warehouse'
										]
									"
									:id="
										form.selected_list[this.get_plenty_id(listKey)][
											'from_warehouse'
										]
									"
									:name="
										form.selected_list[this.get_plenty_id(listKey)][
											'from_warehouse'
										]
									"
								>
									<option
										v-for="(_from_warehouse_akt, _toIndex) in form
											.selected_list[this.get_plenty_id(listKey)][
											'from_warehouses_toBeSelected'
										]"
										:key="_from_warehouse_akt"
										:value="_from_warehouse_akt"
										class="rounded-sm p-4"
									>
										{{ _from_warehouse_akt }}
									</option>
								</select>
							</td>
							<!-- To warehouse  -->
							<td>
								<select
									@change="update_to_warehouse($event, listKey)"
									:value="
										form.selected_list[this.get_plenty_id(listKey)][
											'to_warehouse'
										]
									"
									:id="
										form.selected_list[this.get_plenty_id(listKey)][
											'to_warehouse'
										]
									"
									:name="
										form.selected_list[this.get_plenty_id(listKey)][
											'to_warehouse'
										]
									"
								>
									<option
										v-for="(_to_warehouse, _toIndex) in form.selected_list[
											this.get_plenty_id(listKey)
										]['to_warehouses_toBeSelected']"
										:key="_to_warehouse"
										:value="_to_warehouse"
										class="rounded-sm p-4"
									>
										{{ _to_warehouse }}
									</option>
								</select>
							</td>
							<!-- Existing quantity  -->
							<!-- to_physical_stock -->
							<td>
								{{
									form.selected_list[this.get_plenty_id(listKey)][
										"to_physical_stock"
									]
								}}
							</td>
							<!-- from warehosue stock number  -->
							<td>
								<input
									@change="update_from_stock($event, listKey)"
									:value="
										form.selected_list[this.get_plenty_id(listKey)][
											'from_stock'
										]
									"
									:id="
										form.selected_list[this.get_plenty_id(listKey)][
											'from_stock'
										]
									"
									:name="
										form.selected_list[this.get_plenty_id(listKey)][
											'from_stock'
										]
									"
									class="border border-red-50 p-2"
								/>
							</td>
							<!-- Plenty id -->
							<td>
								<input
									@change="update_comment($event, listKey)"
									:value="
										form.selected_list[this.get_plenty_id(listKey)]['comment']
									"
									:id="'comment' + listKey"
									:name="'comment' + listKey"
									class="border border-red-50 p-2"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</form>
		<!-- v-model="selected" -->
		<!-- @change="updateSelected(stock)" -->
		<!-- {{ list_keys }} -->
		<!-- {{ list_length }} -->
		<!-- {{ transport_list }} -->
	</bernstein-layout>
</template>
<script>
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import { toRefs, toRef } from "vue";
import { useForm } from "@inertiajs/inertia-vue3";
import JetLabel from "@/Jetstream/Label.vue";
import JetInput from "@/Jetstream/Input.vue";

import JetButton from "@/Jetstream/Button.vue";
export default {
	components: {
		BernsteinLayout,
		JetLabel,
		JetInput,
		JetButton,
	},
	data() {
		return {
			warehouseids: [4, 25, 17],
			warehouses: ["Floersheim", "Keramag", "Hochheim"],
			toWarhouse: "Floersheim",
			fromWarehouse: "Hochheim",
			fromKey: "hochheim_physical",
			fromQuantity: 0,
			list_row: [],
			createOriginal: true,
			_test: true,
			email: "",
			lagerHochheim: "lager.hochheim@bernstein-badshop.de",
			lagerKeramag: "lager.keramag@bernstein-badshop.de",
			bUsel: "b.usel@bernstein-badshop.de",
			paketdienst: "lager.paketversand@bernstein-badshop.de",
			// form: this.$inertia.form({
			// 	processing: false,
			// 	selected_list: {},
			// }),
		};
	},

	props: {
		transport_list: Object,
		// list_row: [],
	},
	setup(props) {
		const form = useForm({
			selected_list: {},
			email_list: [],
			// submit_transport_list: [],
			transporting_list: [],
		});
		function get_email_addresses(emailString) {
			let _emailList = "";
			emailString = emailString.toString();
			if (emailString != "") {
				_emailList = emailString.split(/[,;]/g);
			}
			return _emailList;
		}
		function submit_selected_list() {
			// get_email_addresse();
			// let _filtered = this.form.selected_list.filter(function (el) {
			// 	return el != null;
			// });
			this.transporting_list = [];
			// this.form.selected_list = _filtered;
			// console.log(this.form.selected_list);
			let _tr_list = this.form.selected_list;
			let _keys = Object.keys(_tr_list);
			for (let j = 0; j < _keys.length; j++) {
				let _key = _keys[j];
				let _tr_row = {};
				//checked
				if (_tr_list[_key].checked) {
					_tr_row.checked = _tr_list[_key].checked;
					//item id
					_tr_row.itemId = _tr_list[_key].itemId;
					//variationid
					_tr_row.variationId = _tr_list[_key].variationId;
					//name
					_tr_row.name = _tr_list[_key].name;
					//from warehosue
					_tr_row.from_warehouse = _tr_list[_key].from_warehouse;
					//to_warehouse
					_tr_row.to_warehouse = _tr_list[_key].to_warehouse;
					//from_stock number
					_tr_row.stock = _tr_list[_key].from_stock;
					_tr_row.comment = _tr_list[_key].comment;
					this.form.transporting_list.push(_tr_row);
				}
				// console.log(_tr_row)
			}
			// this.form.submit_selected_list = JSON.stringify(_array);
			// this.form.selected_list = this.form.select_list.toJSON();
			this.form.email_list = get_email_addresses(this.form.email_list);
			form.post("/stocks/send_transport-list");
		}
		return { form, submit_selected_list, get_email_addresses };
	},
	computed: {
		list_keys() {
			// console.log(Object.keys(this.transport_list));
			return Object.keys(this.transport_list);
		},
		//length of transport list
		list_length() {
			return Object.keys(this.transport_list).length;
		},
		//list of keys

		get_list_item(listKey) {
			return this.transport_list[listKey];
		},
	},
	methods: {
		arrayRemove(arr, value) {
			return arr.filter(function (ele) {
				return ele != value;
			});
		},
		select_email_from_list($event) {
			this.createOriginal = false;
			if (event.target.checked) {
				this.form.email_list.push($event.target.value);
			} else {
				this.form.email_list = this.arrayRemove(
					this.form.email_list,
					$event.target.value
				);
			}
		},

		// submit_selected_list() {
		// 	this.form.processing = true;
		// 	// let _array = Object.assign({}, this.form.selected_list);
		// 	// console.log(_array);
		// 	// console.log(typeof this.form.selected_list);
		// 	// console.log(this.form.selected_list);
		// 	// this.form.selected_list = JSON.stringify(_array);
		// 	// console.log("submitting ");
		// 	this.form.post("/stocks/send_transport-list", {
		// 		// onFinish: () => this.form.reset("variationId", "variationId"),
		// 	});
		// },

		/**
		 *
		 */
		get_plenty_id: function (listKey) {
			let _plenty_id = this.transport_list[listKey]["plenty_id"];
			_plenty_id = _plenty_id.toString();
			return _plenty_id;
		},
		/**
		 * this function get one row from the transport list
		 * @param {*} kIndx
		 *
		 */
		get_transport_list_row: function (kIndx) {
			//first initialize
			this.form.select_list = [];
			let _key = this.list_keys[kIndx];

			if (this.createOriginal) {
				// console.log(this.transport_list);
				// let _listItem = this.transport_list[_key];
				// let _listItem = structuredClone(this.transport_list[_key]);
				let _listItem = Object.assign({}, this.transport_list[_key]);
				let _plenty_id = _listItem["plenty_id"];
				_plenty_id = _plenty_id.toString();
				//_list row is to display
				let _list_row = [];
				//this is after selection
				let _emailList = [];
				let _selected_list_row = {};
				_selected_list_row["floersheim_net"] = _listItem["floersheim_net"];
				_selected_list_row["keramag_net"] = _listItem["keramag_net"];
				_selected_list_row["hochheim_net"] = _listItem["hochheim_net"];
				//physical
				_selected_list_row["floersheim_physical"] =
					_listItem["floersheim_physical"];
				_selected_list_row["keramag_physical"] = _listItem["keramag_physical"];
				_selected_list_row["hochheim_physical"] =
					_listItem["hochheim_physical"];

				// _selected_list_row.selected_item = _listItem;

				_selected_list_row.checked = true;

				_selected_list_row["itemId"] = _listItem["itemId"];
				//
				_selected_list_row["variationId"] = _plenty_id;
				//name
				_selected_list_row["name"] = _listItem["name"];
				//mainwarehouse
				let _warehouseId = _listItem["mainWarehouseId"];
				let _main_warehouse = this.get_warehosue_name(_warehouseId);
				_selected_list_row["main_warehouse"] = _main_warehouse;

				//to warehouse
				//to warehouse
				_selected_list_row["from_warehouse"] = "";

				_selected_list_row["to_warehouse"] = _main_warehouse;

				//from ware house
				let _warehouseInfo = this.get_fromWarehouse(
					_listItem,
					_selected_list_row
				);
				// console.log(_warehouseInfo);
				_selected_list_row["from_warehouse"] = _warehouseInfo.from_warehouse;
				//
				_selected_list_row["from_stock"] = _warehouseInfo.from_netStock;
				//from warehoues to be selected
				_selected_list_row["from_warehouses_toBeSelected"] = this.warehouses;
				//to warehoues to be selected
				_selected_list_row["to_warehouses_toBeSelected"] =
					_warehouseInfo.to_warehouses;
				//existing quantity
				_selected_list_row["to_physical_stock"] =
					_warehouseInfo.to_physical_stock;
				//comment
				_selected_list_row["comment"] = "";
				this.form.selected_list[this.get_plenty_id(_key)] = _selected_list_row;

				// 	= Object.assign(
				// 	{},
				// 	_selected_list_row
				// );
				// console.log(_warehouseInfo);
				// this.list_row = _selected_list_row;
				// console.log(this.form.selected_list);
				return _selected_list_row;
			} else {
				// console.log(this.createOriginal);
			}
		},
		get_warehosue_name: function (warehouseId) {
			let warehouseIndex = this.warehouseids.indexOf(warehouseId);
			return this.warehouses[warehouseIndex];
		},

		get_fromWarehouse(selectedItem, selected_list_row) {
			// console.log(selected_list_row);
			// console.log(this.form.selected_list);
			let _toWarehouse = selected_list_row["to_warehouse"];
			let _toIndex = this.warehouses.indexOf(_toWarehouse);
			// console.log(_toIndex);
			// let _netStock = [
			// 	selected_list_row["floersheim_net"],
			// 	selected_list_row["keramag_net"],
			// 	selected_list_row["hochheim_net"],
			// ];
			let _physicalStock = [
				selected_list_row["floersheim_physical"],
				selected_list_row["keramag_physical"],
				selected_list_row["hochheim_physical"],
			];
			//
			let _to_physical_stock = _physicalStock[_toIndex];
			// console.log(_physicalStock);
			//
			Array.prototype.except = function (keys) {
				return this.filter((x, i) =>
					keys instanceof Array
						? !keys.includes(i) //  w  w w  . j a v a  2s .com
						: i !== keys
				);
			};
			// console.log(_toIndex);
			let _physical_akt = _physicalStock.except([_toIndex]);
			// console.log(_toIndex);
			let _warehouses_akt = this.warehouses.except(_toIndex);
			// console.log(_physical_akt);
			// console.log(_warehouses_akt);
			// console.log(_warehouses_akt);
			let _fromNumber = Math.max(..._physical_akt);
			let _fromIndex = _physical_akt.indexOf(_fromNumber.toString());
			let _from_warehouse = _warehouses_akt[_fromIndex].toString();
			let _from_warehouseIndex = this.warehouses.indexOf(_from_warehouse);
			let _from_physicalStock = _physical_akt[_fromIndex];
			let _to_warehouses = this.warehouses.except(_from_warehouseIndex);
			// console.log(_to_warehouses);
			return {
				from_warehouse: _from_warehouse,
				from_netStock: _from_physicalStock,
				to_warehouses: _to_warehouses,
				to_physical_stock: _to_physical_stock,
			};
		},
		/***
		 *
		 *
		 */
		get_toPhysicalStock(to_warehouse, listKey) {
			let _key = this.get_plenty_id(listKey);
			let _list_row = this.form.selected_list[_key];
			let _physicalStock = [
				_list_row.floersheim_physical,
				_list_row.keramag_physical,
				_list_row.hochheim_physical,
			];
			let _toIndex = this.warehouses.indexOf(to_warehouse);
			let _to_physical_stock = _physicalStock[_toIndex];
			return _to_physical_stock;
		},
		update_email_list($event) {
			this.createOriginal = false;
			// console.log($event.checked);
			console.log($event.target.value);
			let _emails = this.get_email_addresses($event.target.value);
			// console.log(_emails);
			this.form.email_list = _emails;
			// this.form.email_list = $event.target.value;
		},
		/**
		 *
		 * @param {* String } $event
		 * @param {* plentyId  String } listKey
		 */
		update_comment($event, listKey) {
			console.log(this.form.selected_list);
			this.createOriginal = false;
			let _cur_comment = $event.target.value;
			// console.l();
			this.form.selected_list[this.get_plenty_id(listKey)]["comment"] =
				_cur_comment;
		},
		update_transport_listitem($event, listKey) {
			// console.log(variationId);
			// console.log(this.form.selected_list);
			this.createOriginal = false;
			let _cur_checkedValue = $event.target.value;
			// console.log($event.target.value);
			if (_cur_checkedValue === "true") {
				console.log("true case");
				this.form.selected_list[this.get_plenty_id(listKey)]["checked"] = false;
			} else {
				console.log("false case");
				this.form.selected_list[this.get_plenty_id(listKey)]["checked"] = true;
			}
			// console.log($event.target.value);
			// console.log(this.form.selected_list);
		},

		/**
		 * update
		 * @param {
		 * } $event
		 * @param {*} listKey
		 */
		update_from_warehouse($event, listKey) {
			this.createOriginal = false;
			// console.log(listKey);
			// console.log($event);
			// console.log(this.form.selected_list);
			let _key = this.get_plenty_id(listKey);
			let _list_row = this.form.selected_list[_key];
			// console.log(_list_row);
			let _from_warehouse = $event.target.value;
			let _to_warehouse = _list_row.to_warehouse;
			let _fromIndex = this.warehouses.indexOf(_from_warehouse);
			// console.log(_from_warehouse);
			// console.log(_to_warehouse);

			// console.log(_fromIndex);
			_list_row.from_warehouse = _from_warehouse;

			//list row netstock
			// let _netStock = [
			// 	_list_row["selected_item"].floersheim_net,
			// 	_list_row["selected_item"].keramag_net,
			// 	_list_row["selected_item"].hochheim_net,
			// ];
			let _physicalStock = [
				_list_row.floersheim_physical,
				_list_row.keramag_physical,
				_list_row.hochheim_physical,
			];
			// console.log(_physicalStock);
			let _physicalStock_akt = _physicalStock[_fromIndex];
			// console.log(_physicalStock_akt);
			// //chnage the netstock value
			_list_row["from_stock"] = _physicalStock_akt;
			this.form.selected_list[_key]["from_warehouse"] = _from_warehouse;
			this.form.selected_list[_key]["from_stock"] = _physicalStock_akt;

			// console.log(this.form.selected_list[[listKey]]);
			//finally change the to warehouses also
			let _to_warehouses = this.update_to_warehouses(
				_from_warehouse,
				_to_warehouse
			);
			// console.log(_to_warehouses);
			_to_warehouse = _to_warehouses.to_warehosue;
			let _toIndex = this.warehouses.indexOf(_to_warehouse);
			let _to_physical_stock = _physicalStock[_toIndex];

			// console.log(_to_warehouses.to_warehosue);
			//check if
			this.form.selected_list[_key].to_warehouse = _to_warehouses.to_warehosue;
			this.form.selected_list[_key].to_warehouses_toBeSelected =
				_to_warehouses.to_warehouses;
			this.form.selected_list[_key].to_physical_stock = _to_physical_stock;
			console.log(this.form.selected_list);
		},
		/**
		 *
		 */
		update_to_warehouse($event, listKey) {
			// console.log(listKey);

			this.createOriginal = false;
			let _key = this.get_plenty_id(listKey);
			// let _list_row = this.form.selected_list._key;
			// console.log(_to_warehouse);
			let _to_warehouse = $event.target.value;
			// console.log(_to_warehouse);
			let _toIndex = this.warehouses.indexOf(_to_warehouse);
			let _to_physical_stock = this.get_toPhysicalStock(_to_warehouse, listKey);
			this.form.selected_list[_key]["to_warehouse"] = _to_warehouse;
			this.form.selected_list[_key]["to_physical_stock"] = _to_physical_stock;

			//update to warehouse stock

			// console.log(this.form.selected_list);
		},
		/**
		 *
		 * @param {string} fromWarehouse
		 * @param {string } toWarehouse
		 */
		update_to_warehouses(fromWarehouse, toWarehouse) {
			// console.log(_warehouses_akt[_fromIndex]);
			// console.log(_netStock_akt[_fromIndex]);
			Array.prototype.except = function (keys) {
				return this.filter((x, i) =>
					keys instanceof Array
						? !keys.includes(i) //  w  w w  . j a v a  2s .com
						: i !== keys
				);
			};
			this.createOriginal = false;
			let _from_warehouseIndex = this.warehouses.indexOf(fromWarehouse);
			let _to_warehouses = this.warehouses.except(_from_warehouseIndex);
			// console.log("test");
			// console.log(_to_warehouses);
			// console.log(toWarehouse);
			// console.log(_to_warehouses.includes(toWarehouse));
			if (!_to_warehouses.includes(toWarehouse)) {
				toWarehouse = _to_warehouses[0];
			}
			return {
				to_warehosue: toWarehouse,
				to_warehouses: _to_warehouses,
			};
		},
		/**
		 *
		 * @param {*} $event
		 * @param {*} listKey
		 */
		update_from_stock($event, listKey) {
			this.createOriginal = false;
			let _key = this.get_plenty_id(listKey);
			let _netStock = [
				this.form.selected_list[_key]["floersheim_net"],
				this.form.selected_list[_key]["keramag_net"],
				this.form.selected_list[_key]["hochheim_net"],
			];
			// console.log(_netStock);
			//fix the maximum netstock
			//get from_warehouse
			let _from_warehouse = this.form.selected_list[_key]["from_warehouse"];
			let _from_index = this.warehouses.indexOf(_from_warehouse);
			// console.log(_from_index);
			let _max_netStock = _netStock[_from_index];
			// console.log(_max_netStock);
			let _net_newStock = parseInt($event.target.value);
			// console.log(_net_newStock + " : " + "old: " + _max_netStock);
			if (_net_newStock > _max_netStock) {
				this.form.selected_list[_key]["from_stock"] = _max_netStock;
				_net_newStock = _max_netStock;
				$event.target.value = _max_netStock;
				alert(
					"Die maximale Anzahl an Artikeln beträgt" +
						_max_netStock +
						" Daher können Sie nicht mehr als " +
						_max_netStock +
						" Artikel auswählen. "
				);
			} else {
				this.form.selected_list[_key]["from_stock"] = _net_newStock;
			}
			return _net_newStock;
			// console.log(this.form.selected_list);
		},
	},
};
</script>
